// ------------------------- Maps and Filter ----------------------------
const nums = [1, 2, 3, 4];
export const multiplyThree = nums.map((num, i, arr) => {
	console.log('arr', arr);
	return num * 3 + i;
});
export const moreThanTwo = nums.filter((num) => {
	return num > 2;
});

// ------------------------- indexOf ----------------------------
const names = ['hsu', 'thuta', 'zaw', 'thuta'];
const index = names.indexOf('thuta'); // 1
const LastIndex = names.lastIndexOf('thuta'); // 3
console.log('LastIndex', LastIndex);
console.log('index', index);
names[index] = 'thutasann';
console.log('names', names);

// ------------------------- Reduce ----------------------------
// array.reduce(function(total, currentValue, currentIndex, arr ), initialValue)

const numbers = [1, 2, 3, 4];
export const sum = numbers.reduce((acc, curr, i, arr) => {
	return acc + curr;
}, 0);
export function joinStrings(acc: string, curr: string): string {
	return acc + curr;
}
export function sumReducer(acc: number, curr: number): number {
	return acc + curr;
}
// Remove Duplicate Itmes from Array
const ageGroup = [18, 21, 1, 1, 51, 18, 21, 5, 18, 7, 10];
export const uniqueAgeGroup = ageGroup.reduce(function (
	accu: number[],
	currentValue: number,
): number[] {
	if (accu.indexOf(currentValue)) {
		accu.push(currentValue);
	}
	return accu;
},
[]);

// with TypeScript
const personArr = [{ firstName: 'thuta' }, { lastName: 'sann' }];
export const ReducedPersons = personArr.reduce<IPerson>((acc, curr) => {
	return {
		...acc,
		...curr,
	};
}, {} as IPerson);

const arr: number[] = [10, 4, 7, 3];
const SumToGetAvg: number = arr.reduce<number>((acc, curr) => {
	return acc + curr;
}, 0 as number);
export const average = arr.length / SumToGetAvg;

const ArrObj = [{ value: 32 }, { value: 12 }, { value: 4 }];
export const SumArrObj: number = ArrObj.reduce<number>((a, b) => {
	console.log('a', a);
	return a + b.value;
}, 0 as number);

const Staffs: IStaffs[] = [
	{
		role: 'admin',
		value: 10,
	},
	{
		role: 'manager',
		value: 30,
	},
	{
		role: 'admin',
		value: 40,
	},
];
export const FilterAndSumValues = Staffs.filter(
	({ role }) => role === 'admin',
).reduce<number>((sum: number, staff: IStaffs) => {
	return sum + staff.value;
}, 0 as number);

export function SUMARR(arr: number[]): number {
	const reducer = (total: number, value: number) => total + value;
	return arr.reduce<number>(reducer, 0);
}

export const DATES = [
	'01/08/2022',
	'02/08/2022',
	'04/08/2022', // THis is the most recent date
	'04/07/2022',
].map((val: string) => new Date(val));
export const maxDate = DATES.reduce(
	(max: any, d) => (d > max ? d : max),
	DATES[0],
);

// ------------------------- Question ----------------------------
